import {
    deleteEntity,
    editEntity,
    getEntity,
    getEntityWithParams,
    getEntityWithQueryParams
} from "../../utils/ReqestEntityUtils";
import {Category, Credits, Item, Order, Token} from "../../entity/Entity";
import {URLs} from "./Urls";


// items
export function GetItemsByCategory(category: string): Promise<Item[]> {
    return getEntityWithQueryParams(URLs.GetItems, {"category": category})
}

export function GetItemByID(id: string): Promise<Item[]> {
    return getEntity(URLs.GetItems,id)
}


export function AddItem(i: Item): Promise<any> {
    return editEntity(URLs.AddItem, i)
}


export function DelItem(id: string): Promise<string> {
    return deleteEntity(URLs.DelItem,id)
}

// orders
export const GetOrdersByStatus = async (
    status: string
): Promise<Order[]> =>
    getEntityWithQueryParams<Order[]>(URLs.GetOrders, { status })
        .catch(() => []);


export function GetOrderByID(id: string): Promise<Item[]> {
    return getEntity(URLs.GetOrders,id)
}

export function AddOrder(i: Order): Promise<any> {
    return editEntity(URLs.AddOrder, i)
}

export function DelOrder(id: string): Promise<string> {
    return deleteEntity(URLs.DelOrder,id)
}

// categories

export function GetCategories(): Promise<Category[]> {
    return getEntity(URLs.GetCategories)
}


export function AddCategory(i: Item): Promise<any> {
    return editEntity(URLs.AddCategory, i)
}

export function DelCategory(id: string): Promise<string> {
    return deleteEntity(URLs.DelCategory,id)
}

export function LoginRequest(data: Credits): Promise<Token> {
    return getEntityWithParams<Token, Credits>(URLs.Login, data);
}



